function d2h(d)
{
    var h = (d).toString(16);
    return h.length % 2 ? '0' + h : h;
}
export default d2h;
